import { UUID } from '@/types';
import { useDatasourceId } from '@/hooks';
import { GET_SAVED_QUERIES, usePrefetch } from '../apiSlice';

export const usePrefetchDependantSavedQueries = (seriesIds: UUID[]) => {
  const datasourceId = useDatasourceId();
  const prefetchSavedQueries = usePrefetch(GET_SAVED_QUERIES, {
    ifOlderThan: 10,
  });

  return () => prefetchSavedQueries({ datasourceId, seriesIds });
};
